"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1608))
 * @lastsynced 2026-10-29T13:50:59.563Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Exclamation = createSVGIcon(
  <>
    <path
      d="M11.143 16.286a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0"
      fill="currentColor"
    />
    <path
      d="M12 6v5.143M.857 12a11.143 11.143 0 1 0 22.286 0A11.143 11.143 0 0 0 .857 12Zm10.286 4.286a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </>,
  "Exclamation",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
